export const tabConfig = {
  'base-params': {
    value: 'base-params',
    label: 'Parameter',
  },
  walls: {
    value: 'walls',
    label: 'Wände',
  },
  roofs: {
    value: 'roofs',
    label: 'Dach',
  },
  results: {
    value: 'results',
    label: 'Resultate',
  },
}
